// import {
//   GET_LABELS_REQUEST,
//   GET_LABELS_SUCCESS,
//   GET_LABELS_FAILURE,
//   GET_LABELS_WITH_PAGINATION_REQUEST,
//   GET_LABELS_WITH_PAGINATION_SUCCESS,
//   GET_LABELS_WITH_PAGINATION_FAILURE,
//   GET_PRINTERS_FOR_LABEL_REQUEST,
//   GET_PRINTERS_FOR_LABEL_SUCCESS,
//   GET_PRINTERS_FOR_LABEL_FAILURE,
// } from "./labelCreationTypes";
import {
  GET_LOCATIONS_BY_MACHINE_FAILURE,
  GET_LOCATIONS_BY_MACHINE_REQUEST,
  GET_LOCATIONS_BY_MACHINE_SUCCESS,
  GET_MACHINE_CENTER_FAILURE,
  GET_MACHINE_CENTER_REQUEST,
  GET_MACHINE_CENTER_SUCCESS,
  GET_MACHINE_FOR_DROPDOWN_FAILURE,
  GET_MACHINE_FOR_DROPDOWN_REQUEST,
  GET_MACHINE_FOR_DROPDOWN_SUCCESS,
  GET_WORKCENTER_BY_MACHINE_FAILURE,
  GET_WORKCENTER_BY_MACHINE_REQUEST,
  GET_WORKCENTER_BY_MACHINE_SUCCESS,
  GET_MAPPED_MACHINES_REQUEST,
  GET_MAPPED_MACHINES_SUCCESS,
  GET_MAPPED_MACHINES_FAILURE,
} from "./machineCenterTypes";

const initialState = {
  loading: false,
  labels: [],
  error: "",
};

const getMachineCenterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MACHINE_CENTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MACHINE_CENTER_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_MACHINE_CENTER_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStatemACHINE = {
  loading: false,
  labels: [],
  error: "",
};

const getMachineCenterForDropDownReducer = (
  state = initialStatemACHINE,
  action
) => {
  switch (action.type) {
    case GET_MACHINE_FOR_DROPDOWN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MACHINE_FOR_DROPDOWN_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_MACHINE_FOR_DROPDOWN_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateMachine = {
  loading: false,
  labels: [],
  error: "",
};

const getLocationsForMachineReducer = (state = initialStateMachine, action) => {
  switch (action.type) {
    case GET_LOCATIONS_BY_MACHINE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_LOCATIONS_BY_MACHINE_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_LOCATIONS_BY_MACHINE_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateMachineR = {
  loading: false,
  labels: [],
  error: "",
};

const getWorkCenterReducer = (state = initialStateMachineR, action) => {
  switch (action.type) {
    case GET_WORKCENTER_BY_MACHINE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_WORKCENTER_BY_MACHINE_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_WORKCENTER_BY_MACHINE_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForMappedMachines = {
  loading: false,
  labels: [],
  error: "",
};

const getMappedMachinesReducer = (
  state = initialStateForMappedMachines,
  action
) => {
  switch (action.type) {
    case GET_MAPPED_MACHINES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MAPPED_MACHINES_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_MAPPED_MACHINES_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getMachineCenterReducer,
  getLocationsForMachineReducer,
  getWorkCenterReducer,
  getMachineCenterForDropDownReducer,
  getMappedMachinesReducer,
};
